var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routesView p10"},[_c('el-breadcrumb',[_vm._l((_vm.routes),function(item){return [(!item.path)?_c('el-breadcrumb-item',[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.path)?_c('el-breadcrumb-item',{attrs:{"to":{ path: item.path, query: item.query }}},[_vm._v(_vm._s(item.name))]):_vm._e()]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ededf0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/jh/pages/home/components/bread/index.vue
// module id = null
// module chunks = 